import React from "react";
import PropTypes from "prop-types";

const SortableHeader = ({ value, sort, direction, handleSort, children }) => {
  if (value === sort) {
    if (direction === "asc") {
      return (
        <th
          className="sortable-header runsheets-table-head"
          onClick={() => handleSort({ sort, direction: "desc" })}
        >
          {children}
          <span className="glyphicon glyphicon-arrow-up" aria-hidden="true" />
        </th>
      );
    }
    return (
      <th
        className="sortable-header runsheets-table-head"
        onClick={() => handleSort({ sort, direction: "asc" })}
      >
        {children}
        <span className="glyphicon glyphicon-arrow-down" aria-hidden="true" />
      </th>
    );
  }
  return (
    <th
      className="sortable-header runsheets-table-head"
      onClick={() => handleSort({ sort: value, direction })}
    >
      {children}
    </th>
  );
};
SortableHeader.propTypes = {
  value: PropTypes.string.isRequired,
  sort: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  handleSort: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default SortableHeader;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/SortableHeader.js